import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AssetThumbScrub_AudioAsset_Fragment = { __typename?: 'AudioAsset' };

export type AssetThumbScrub_DocumentAsset_Fragment = { __typename?: 'DocumentAsset', media?: { __typename?: 'DocumentMedia', id: string, metadata?: { __typename?: 'DocumentMetadata', id?: string | null, originalHeight?: number | null, originalWidth?: number | null } | null, thumbScrubSprite?: { __typename?: 'ThumbScrubSheet', frames?: number | null, streamUrl?: string | null, tileX?: number | null, tileY?: number | null } | { __typename?: 'ThumbScrubStrip', frames?: number | null, streamUrl?: string | null, tileX?: number | null, tileY?: number | null } | null } | null };

export type AssetThumbScrub_FileAsset_Fragment = { __typename?: 'FileAsset' };

export type AssetThumbScrub_FolderAsset_Fragment = { __typename?: 'FolderAsset' };

export type AssetThumbScrub_ImageAsset_Fragment = { __typename?: 'ImageAsset' };

export type AssetThumbScrub_InteractiveAsset_Fragment = { __typename?: 'InteractiveAsset' };

export type AssetThumbScrub_InteractiveLiveAsset_Fragment = { __typename?: 'InteractiveLiveAsset' };

export type AssetThumbScrub_ModelAsset_Fragment = { __typename?: 'ModelAsset', media?: { __typename?: 'ModelMedia', id: string, metadata?: { __typename?: 'ModelMetadata', id?: string | null, originalHeight?: number | null, originalWidth?: number | null } | null, thumbScrubSprite?: { __typename?: 'ThumbScrubSheet', frames?: number | null, streamUrl?: string | null, tileX?: number | null, tileY?: number | null } | { __typename?: 'ThumbScrubStrip', frames?: number | null, streamUrl?: string | null, tileX?: number | null, tileY?: number | null } | null } | null };

export type AssetThumbScrub_UnsupportedAsset_Fragment = { __typename?: 'UnsupportedAsset' };

export type AssetThumbScrub_VersionStackAsset_Fragment = { __typename?: 'VersionStackAsset' };

export type AssetThumbScrub_VideoAsset_Fragment = { __typename?: 'VideoAsset', media?: { __typename?: 'VideoMedia', id: string, metadata?: { __typename?: 'VideoMetadata', id?: string | null, originalHeight?: number | null, originalWidth?: number | null } | null, thumbScrubSprite?: { __typename?: 'ThumbScrubSheet', frames?: number | null, streamUrl?: string | null, tileX?: number | null, tileY?: number | null } | { __typename?: 'ThumbScrubStrip', frames?: number | null, streamUrl?: string | null, tileX?: number | null, tileY?: number | null } | null } | null };

export type AssetThumbScrubFragment = AssetThumbScrub_AudioAsset_Fragment | AssetThumbScrub_DocumentAsset_Fragment | AssetThumbScrub_FileAsset_Fragment | AssetThumbScrub_FolderAsset_Fragment | AssetThumbScrub_ImageAsset_Fragment | AssetThumbScrub_InteractiveAsset_Fragment | AssetThumbScrub_InteractiveLiveAsset_Fragment | AssetThumbScrub_ModelAsset_Fragment | AssetThumbScrub_UnsupportedAsset_Fragment | AssetThumbScrub_VersionStackAsset_Fragment | AssetThumbScrub_VideoAsset_Fragment;

export const AssetThumbScrub = /*#__PURE__*/ gql`
    fragment AssetThumbScrub on Asset {
  ... on VideoAsset {
    media {
      id
      metadata {
        id
        originalHeight
        originalWidth
      }
      thumbScrubSprite {
        frames
        streamUrl
        tileX
        tileY
      }
    }
  }
  ... on DocumentAsset {
    media {
      id
      metadata {
        id
        originalHeight
        originalWidth
      }
      thumbScrubSprite {
        frames
        streamUrl
        tileX
        tileY
      }
    }
  }
  ... on ModelAsset {
    media {
      id
      metadata {
        id
        originalHeight
        originalWidth
      }
      thumbScrubSprite {
        frames
        streamUrl
        tileX
        tileY
      }
    }
  }
}
    ` as unknown as DocumentNode<AssetThumbScrubFragment, unknown>;

        

        
export const useAssetThumbScrubFragment = (
  input: string | Omit<UseFragmentOptions<AssetThumbScrubFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Asset' } };
    return input;
  })();

  return useFragment<AssetThumbScrubFragment>({
    fragment: AssetThumbScrub,
    fragmentName: 'AssetThumbScrub',
    ...options,
  });
};
  
        